var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v(" KeyVue, supporting your business. Copyright 2020. ")])}
var staticRenderFns = []

export { render, staticRenderFns }